function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "ebook_svg__cls-2",
  d: "M93.39 118.27H39.15c-5.47 0-9.92-4.45-9.92-9.92V24.18c0-5.47 4.45-9.92 9.92-9.92h54.24c5.47 0 9.92 4.45 9.92 9.92v84.17c0 5.47-4.45 9.92-9.92 9.92zm-54.24-99a4.93 4.93 0 00-4.92 4.92v84.16a4.93 4.93 0 004.92 4.92h54.24a4.93 4.93 0 004.92-4.92V24.18a4.93 4.93 0 00-4.92-4.92H39.15z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "ebook_svg__cls-2",
  d: "M86.42 40H46.11a2.5 2.5 0 010-5h40.31a2.5 2.5 0 010 5zM86.42 58H46.11a2.5 2.5 0 010-5h40.31a2.5 2.5 0 010 5zM72.42 76H46.11a2.5 2.5 0 010-5h26.31a2.5 2.5 0 010 5z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "ebook_svg__cls-2",
  cx: 66.27,
  cy: 100,
  r: 5.73
});

function SvgEbook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ebook_svg__Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.54 132.54",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgEbook;